

export default (function ($) {

    var _instance = {
        current_page: 1,
        total_pages: null
    }

    _instance.initContributions = function() {
        var $contibutions = $('.js-contribution');
        var $contibutionsForm = $('#contributionsForm');
        var $contributionsWrap = $("#contributionsWrap");

        var contributionTemplate = wp.template('contribution');

        var formData = {};
        $contibutionsForm.serializeArray().map(function (x) { formData[x.name] = x.value; });


        $contibutions.html('<div class="col-12"><h4>Loading...</h4></div>');

        var showNoResults = function () {
            $contibutions.html('<div class="col-12"><h4>No Contributions Yet!</h4></div>');
            $contributionsWrap.find(".pagination").hide();
        }

        $.get(
            "/wp-json/v1/author-contributions",
            {
                author_id: $('[name="author_id"]').val(),
                filter: $('.js-filter').val(),
            },
            function (data) {

                _instance.posts = data.posts;

                if (data.posts && data.posts.length > 0) {
                    _instance.total_pages = Math.ceil(data.posts.length / 30);

                    var posts_length = (data.posts.length >= 30) ? 30 : data.posts.length;

                    $contibutions.html('');
                    for (var i = 0; i < posts_length; i++) {
                        $contibutions.append(contributionTemplate(data.posts[i]));
                    }

                    if (data.posts.length > 12) {
                        $contributionsWrap.find(".pagination").show();
                    } else {
                        $contributionsWrap.find(".pagination").hide();
                    }

                    _instance.updateNavigation(_instance.total_pages);

                } else {
                    showNoResults();
                }
            }
        ).fail(function () {
            showNoResults();
        })
    }

    _instance.renderContributions = function () {
        var $contibutions = $('.js-contribution');
        var contributionTemplate = wp.template('contribution');

        var start_post_number = ( _instance.current_page - 1 ) * 30;
        var end_post_number = _instance.current_page * 30;
        var shown_posts = _instance.posts.slice(start_post_number, end_post_number); 

        var posts_length = (shown_posts.length >= 30) ? 30 : shown_posts.length;

        $contibutions.html('');
        for (var i = 0; i < posts_length; i++) {
            $contibutions.append(contributionTemplate(shown_posts[i]));
        }

        _instance.updateNavigation(_instance.total_pages);
    }

    _instance.updateNavigation = function (num_of_pages) {

        $(".js-prev").addClass("disabled");
        $(".js-next").addClass("disabled");

        if (num_of_pages <= 1) return false;

        $(".js-page-item").remove();

        var start_page = (_instance.current_page > 3) ? (_instance.current_page - 4) : 0;
        if((start_page + 7) < _instance.total_pages) {
            var end_page = (start_page + 7);
        } else {
            var end_page = _instance.total_pages;
            start_page = (end_page - 7) > 0 ?  (end_page - 7) : 0;
        }

        for (var i = start_page; i < end_page; i++) {
            $('<li class="page-item js-page-item ' + (((i + 1) === _instance.current_page) ? 'active' : '') + '" data-number="' + (i + 1) + '"><span class="page-link">' + (i + 1) + '</span></li>').insertBefore(".js-next");
        }

        if (_instance.current_page === _instance.total_pages) {
            $(".js-prev").removeClass("disabled");
        } else if (_instance.current_page === 1) {
            $(".js-next").removeClass("disabled");
        } else {
            $(".js-next").removeClass("disabled");
            $(".js-prev").removeClass("disabled");
        }
    }

    _instance.scrollToTop = function () {
        $([document.documentElement, document.body]).animate({
            scrollTop: _instance.$contributionsWrap.offset().top
        }, 500);
    }

    _instance.goToPage = function (page_number) {
        _instance.current_page = parseInt(page_number);
        _instance.scrollToTop();
        _instance.renderContributions();
    }

    _instance.nextPage = function () {
        _instance.current_page++;
        _instance.scrollToTop();
        _instance.renderContributions();
    }

    _instance.prevousPage = function () {
        _instance.current_page--;
        _instance.scrollToTop();
        _instance.renderContributions();
    }

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            _instance.$contributionsWrap = $("#contributionsWrap");

            if (_instance.$contributionsWrap.length === 0) return false;

            _instance.initContributions();
            $(".js-next").not('.disabled').on("click", _instance.nextPage);
            $(".js-prev").not('.disabled').on("click", _instance.prevousPage);

            $(".js-filter").on("change", function () {
                _instance.current_page = 1;
                _instance.initContributions();
            });

            $(document).on("click", '.js-page-item', function () {
                _instance.goToPage($(this).data("number"));
            });
        });
    };

    return _instance;

})(jQuery)